/**
 * Copy-to-clipboard from another element's textContent.
 *
 * Usage:
 *   <pre id="payload">{{ data|pretty_json }}</pre>
 *   <button data-copy-from="#payload"><i class="fa-solid fa-clipboard"></i></button>
 *
 * Briefly swaps the inner <i> icon to fa-check on success.  `data-copy-toast="Copied"` on the
 * button also shows that toast, and an error toast when the browser refuses the copy.
 */

(function () {
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-copy-from]');
        if (!btn) return;
        e.preventDefault();
        var selector = btn.getAttribute('data-copy-from');
        var source = selector ? document.querySelector(selector) : null;
        if (!source) return;
        var toast = btn.getAttribute('data-copy-toast');
        navigator.clipboard.writeText(source.textContent).then(function () {
            if (toast && window.SeeMe && SeeMe.toast) SeeMe.toast.success(toast);
            var icon = btn.querySelector('i');
            if (!icon) return;
            var original = icon.className;
            icon.className = 'fa-solid fa-check';
            setTimeout(function () { icon.className = original; }, 1500);
        }).catch(function () {
            if (toast && window.SeeMe && SeeMe.toast) SeeMe.toast.error('Could not copy to the clipboard');
        });
    });
})();
